import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	genericLifetimeSubheading: {
		id: 'redesign.purchase.purchaseForm.lifetime.priceSubtitle',
		defaultMessage: 'One time payment of {formattedPrice}',
		description: 'Subheading with discount for subscribe form with lifetime coupon',
	},
});
